import Layout from '@/views/layout'

export default [
  {
    path: '/intelligence',
    name: 'intelligence',
    redirect: '/intelligence/selfDiagnose',
    component: Layout,
    meta: {
      title: '智能大脑',
      icon: 'brain.png',
      type: 'shop',
      index: 2
    },
    children: [
      {
        path: 'competitiveAnalysis',
        name: 'competitiveAnalysis',
        componentName: 'intelligence_competitiveAnalysis',
        meta: {
          title: '同城竞争力分析'
        },
        component: () => import('@/views/intelligence/competitiveAnalysis')
      },
      {
        path: 'selfDiagnose',
        name: 'selfDiagnose',
        componentName: 'intelligence_selfDiagnose',
        meta: {
          title: '商家自我诊断'
        },
        component: () => import('@/views/intelligence/selfDiagnose')
      }
    ]
  }
]